import styled from 'styled-components';
import color from 'tinycolor2';
import { Menu as MenuComponent, Button, AnchorLink } from '@pearsontechnology/aero-components';

export const Menu = styled(MenuComponent)`
  margin-top: 10px;
  margin-right: 12px;
  word-break: normal;
`;

export const MenuListItemText = styled.div`
  margin: 0 8px;
`;

export const DownloadButton = styled(Button)`
  background: transparent;
  padding: 0px;
  margin-right: 15px;
  &:hover,
  &:focus,
  &:active {
    background: transparent;
  }
`;

export const KnowledgeMapDownloadLink = styled(AnchorLink)`
  background-color: ${(props) => color(props.theme['color.primary.text']).setAlpha(0.1).toString()};
  display: table-cell;
  height: 40px;
  padding: 0 5px;
  text-align: center;
  vertical-align: middle;
  transition-property: color, background-color, box-shadow;
  transition-duration: 0.3s;
  transition-timing-function: ease;
  &:hover,
  &:focus,
  &:active {
    background-color: ${(props) => color(props.theme['color.primary.text']).setAlpha(0.2).toString()};
  }

  &:focus {
    box-shadow: 0 0 0 1px ${(props) => color(props.theme['color.primary.text']).setAlpha(0.3).toString()};
  }
  span{
    display: none;
  }
`;
